module.exports = __webpack_public_path__ + "img/7.67230326.jpg";